/*global require, ZEROCLIPBOARD_MOVIE_PATH, MOJO_CURRENT_LINK_USER, INITIAL_STATE*/
// FILETYPE: PUBLIC

require(
  ['jquery', 'tabs', 'zeroclipboard', 'utils', 'mojo-analytics'],
  function($, Tabs, ZeroClipboard, utils, MojoAnalytics) {
    'use strict';
    /*_______ MODERATORS _______ */
    /* Allow moderators to make offer live or back to pending moderation */
    $('.moderation_toggle').click(function() {
      $.ajax({
        url: $(this).attr('api'),
        type: 'POST',
        dataType: 'json',
        data: {},
        headers: {
          "X-CSRFTOKEN": utils.getCookie('csrftoken')
        }
      })
      .done(function(data, textStatus, jsXHR) {
          window.location.replace('');
      }).fail(function(xhr, status, err) {
          window.alert(err);
      });
      return false;
    });

    /* _______ CONTROL BAR _______ */
    // Click-to-Copy Share URL
    var $short_url = $('#short_url').html();
    ZeroClipboard.config({
        moviePath: ZEROCLIPBOARD_MOVIE_PATH
    });
    var client = new ZeroClipboard(document.getElementById("copy_short_url"));
    client.on("complete", function(client, args) {
        var icon = $(this).html();
        var width = $(this).css('width');
        $(this).addClass('active').html('<i class="icon icon-ok-sign"></i> Copied!');
        $(this).animate({
            'opacity': '1'
        }, 2000, function() {
            $(this).removeClass('active').html(icon);
        });
    });

    $('#short_url').click(function() {
        $(this).select();
    });

    $('#palm_short_url_select').click(function(e) {
        e.preventDefault();
        $('#short_url').select();
    });

    $('.nav--dropdown__parent > a').click(function(e) {
        e.preventDefault();

        if( !$(this).parent().hasClass('active') ) {
            $('.nav--dropdown__parent.active').children('a').click();
        }

        $(this).parent().toggleClass('active');
    });

    /* _______ SHORTLINK EDITOR _______ */
    if ($('#edit_shortlink').length > 0) {
        require(['jquery', 'immoral'], function($) {
            $('#edit_shortlink').immoral({
                modalCloseButton: '<a href="#" rel="modal:close" class="modal--ui-close">&times;</a>',
                modalStyle: {
                    'width': '400px',
                    'height': '250px',
                    'margin': '5% auto',
                    'background': 'white'
                }
            });
        });
    }

    /* _______ OFFER TOGGLE _______ */
    $('.offermode_toggle').click(function() {
        $('.offermode_toggle').hide();
        $.ajax({
  				url: $(this).attr('api'),
  				type: 'POST',
  				dataType: 'json',
  				data: {},
  				headers: {
  					"X-CSRFTOKEN": utils.getCookie('csrftoken')
  				}
  			})
        .done(function () {
            $('.offermode_toggle_container').toggle();
        })
        .always(function () {
            $('.offermode_toggle').show();
        });
        return false;
    });


    /* _______ DISCOUNT _______ */
    if (window.discount_box) {
        require(['jquery', 'immoral'], function($) {
            $('#discount_box_link').immoral({
                modalCloseButton: '<a href="#" rel="modal:close" class="modal--ui-close">&times;</a>',
                modalStyle: {
                    'width': '350px',
                    'height': '210px',
                    'margin': '2em auto',
                    'background': '#FFF'
                }
            });
        });
    }

    /* _______ LOAD THE RIGHT IMAGE_______ */
    var $previewImage = $('#offer_preview_image');

    if ($previewImage.length !== 0) {
        var device = utils.getDeviceType();
        if (device === 'palm' || device === 'portable') {
            if (utils.isRetinaDisplay()) {
                $previewImage.attr('src', $previewImage.data().deskSrc);
            }
        } else if (device === 'desk' || device === 'desk-wide') {
            if (utils.isRetinaDisplay()) {
                $previewImage.attr('src', $previewImage.data().retinaSrc);
            } else {
                $previewImage.attr('src', $previewImage.data().deskSrc);
            }
        }
    }

    // used elsewhere to detect the state of the #offer_header_area
    var scrolling;

    // Used to detect when automatic scrolling is happening.
    // Some events are to be attached with only user scrolling.
    var autoscrolling = false;

    // #offer_header_area height
    var ctaAreaHeight;

    // Checks if ctaButton was clicked or not
    var ctaButton = false;

    /* _____ PAGE READY _____ */
    $(function() {
        /* Make Offer CTA area same height as Offer Heading Area for arrow to work properly */
        var isTouch = window.Modernizr && window.Modernizr.touch;
        var heightHeadlineArea = $('#offer_header_area').height();
        if ($(window).width() > 480) {
            $('.offer_cta').css('height', heightHeadlineArea);
        }

        var $buyCta = $('#buy-cta');

        /* When 'Get it Now! button is clicked */
        $buyCta.on('click', function(e) {
          e.preventDefault();
          if (!$buyCta.hasClass('disabled')) {
            window.isPaymentButtonClicked = true;
          }
        });

        ctaAreaHeight = $('#offer_header_area').height();
        var scrollArea = $('#top_bar_area').height() + ctaAreaHeight;
        // var buyFormHeight = $('#buy_form_area').height();

        /* Push "Powered by Instamojo" footer down even when there is not enough content */
        var offerwindowHeight = $(window).height() - 300;
        if ($('#offer_details_area').height() < offerwindowHeight) {
            $('#offer_details_area').css('min-height', offerwindowHeight);
        }

        // if( MOJO_CURRENT_LINK_USER == MojoUser.username ) {
        //   var OFFER_TOUR = 'offerPage';
        //   var BUYFORM_TOUR = 'buyForm';
        //   tours.getTourData(null, function (data) {
        //     tours.startTour(OFFER_TOUR, data.tours[OFFER_TOUR]);
        //     $('#juspay-form').on('submit',function() {
        //       tours.startTour(BUYFORM_TOUR, data.tours[BUYFORM_TOUR]);
        //     })
        //   });
        // }

        var paymentModuleReadyChecker = setInterval(function () {
          if (window.isPaymentsPopupReady) {
            var $buyCta = $('#buy-cta');
            $buyCta.removeClass('disabled');

            // Embedded Functions
            var intent = utils.getURLParameter('intent');
            if (intent === "buy") {
                $('#admin_top_bar_area').hide();
                $('#top_bar_area').hide();
                $buyCta.click();
            }
            clearInterval(paymentModuleReadyChecker);
          }
        }, 100);
    });

    //Collection
    var $pathnameArray = location.pathname.split('/');

    $('.btn--collection').click(function() {
      $('.collection-wrapper').addClass('collection-wrapper--show');
      $('.collection-overlay').removeClass('hide');

      ga(function(tracker) {
        var $clientId = tracker.get('clientId');
        MojoAnalytics.sendEvent({
          eventName: 'Clicked Collection',
          eventData: {
            offer_id: $pathnameArray[2] ? $pathnameArray[2] : null,
            ga_client_id: $clientId,
            button_source: 'offer',
            seller_username: $pathnameArray[1] ? $pathnameArray[1] : null,
            collection_text: document.getElementsByClassName('btn--collection')[0].innerText.trim(),
          }
        });
      });
    });

    $('#close--collection').click(function() {
      $('.collection-wrapper').removeClass('collection-wrapper--show');
      $('.collection-overlay').addClass('hide');
      $('#collection-form').removeClass('hide');
      $('.success-message-block').addClass('hide');
      $('.collection-error-block').addClass('hide');
      $('#notifyEmail').val('');
    });

    $('.collection-overlay').on('keyup', '#notifyEmail', function () {
      $('.collection-error-block').addClass('hide');
    });

    $('#collection-form').submit(function(e) {
      e.preventDefault();
      var notifyEmail = $('#notifyEmail').val();
      var slug = INITIAL_STATE.offer.slug.split('/')[2];
      var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailRegex.test(notifyEmail)) {
        $.ajax({
          url: '/collection/interested/',
          type: 'POST',
          dataType: 'json',
          data: {
            product: slug,
            email: notifyEmail,
          },
          headers: {
            "X-CSRFTOKEN": utils.getCookie('csrftoken')
          }
        })
        .done(function(data, textStatus, jsXHR) {
          $('#collection-form').addClass('hide');
          $('.success-message-block').removeClass('hide');
          ga(function(tracker) {
            var $clientId = tracker.get('clientId');
            MojoAnalytics.sendEvent({
              eventName: 'Added to Collection',
              eventData: {
                offer_id: $pathnameArray[2] ? $pathnameArray[2] : null,
                ga_client_id: $clientId,
                button_source: 'offer',
                seller_username: $pathnameArray[1] ? $pathnameArray[1] : null,
                visitor_email: notifyEmail,
                collection_text: document.getElementsByClassName('btn--collection')[0].innerText.trim(),
              }
            });
          });
        }).fail(function(xhr, status, err) {
          var errorMsg = JSON.parse(xhr.responseText).__all__[0];
          $('.collection-error-block').html('<li>'+ errorMsg +'</li>');
          $('.collection-error-block').removeClass('hide');
        });
      }
      else {
        $('.collection-error-block').html('<li>Please enter a valid Email Address.</li>');
        $('.collection-error-block').removeClass('hide');
      }
    })
});

define("offer", function(){});

